module.exports = __webpack_public_path__ + "img/ev-logo.52a07a72.png";